import { PlotReportFactElement, PlotReportFactLabelFilter, R1FactType } from './fact';
import { OrganizationProduct } from './organization';

export type PlotReport = {
  plot_id: string;
  facts: PlotReportFactElement[];
};

export type FactsByFactType = Record<R1FactType | string, PlotReportFactElement>;

/**
 * GET /api/v1/dashboard/plot-reports/{project_id}
 */
export const GET_DASHBOARD_PLOT_REPORTS_PATH = 'dashboard/plot-reports/{project_id}';
export type GetDashboardPlotReportsRequestPathVariables = { project_id: string };

export type GetDashboardPlotReportsRequestQueryParams = PlotReportFactLabelFilter & { plot_id?: string[] };
export type GetDashboardPlotReportsSuccessDto = {
  plot_reports: PlotReport[];
};

export type GetDashboardPlotReportsErrorDto = Error;

/**
 * GET /api/v1/dashboard/plot-report/{plot_id}
 */
export const GET_DASHBOARD_PLOT_REPORT_PATH = 'dashboard/plot-report/{plot_id}';
export type GetDashboardPlotReportRequestPathVariables = { plot_id: string };

export type GetDashboardPlotReportRequestQueryParams =
  | (PlotReportFactLabelFilter & { plot_group_id?: string; fact_names?: string })
  | undefined;
export type GetDashboardPlotReportSuccessDto = PlotReport;

export type GetDashboardPlotReportErrorDto = Error;

/**
 * GET /api/v1/dashboard/buyer/plot-reports/{project_id}/
 */
export const GET_BUYER_DASHBOARD_PLOT_REPORTS_PATH = 'dashboard/buyer/plot-reports/{project_id}/';
export type GetBuyerDashboardPlotReportsRequestPathVariables = { project_id: string };

export type GetBuyerDashboardPlotReportsRequestQueryParams = PlotReportFactLabelFilter & { plot_id?: string[] };
export type GetBuyerDashboardPlotReportsSuccessDto = {
  plot_reports: PlotReport[];
};

export type GetBuyerDashboardPlotReportsErrorDto = Error;

/**
 * GET /api/v1/dashboard/buyer/plot-report/{plot_id}/
 */
export const GET_BUYER_DASHBOARD_PLOT_REPORT_PATH = 'dashboard/buyer/plot-report/{plot_id}/';
export type GetBuyerDashboardPlotReportRequestPathVariables = { plot_id: string };

export type GetBuyerDashboardPlotReportRequestQueryParams = PlotReportFactLabelFilter | undefined;
export type GetBuyerDashboardPlotReportSuccessDto = PlotReport;

export type GetBuyerDashboardPlotReportErrorDto = Error;

/**
 * GET /api/v1/dashboard/organization-product/
 */
export const GET_DASHBOARD_ORGANIZATION_PRODUCT_PATH = 'dashboard/organization-product';
export type GetDashboardOrganizationProductRequestPathVariables = undefined;
export type GetDashboardOrganizationProductRequestQueryParams = {
  organization_id: string;
  purchased?: boolean;
};
export type GetDashboardOrganizationProductSuccessDto = OrganizationProduct[];
export type GetDashboardOrganizationProductErrorDto = Error;
